import script from "./DevExample.vue?vue&type=script&lang=ts&setup=true"
export * from "./DevExample.vue?vue&type=script&lang=ts&setup=true"

import "./DevExample.vue?vue&type=style&index=0&id=a6dab8b2&lang=scss"

const __exports__ = script;

export default __exports__